export const favicons = {
    PAYCOR: 'assets/img/favicon_paycor.png',
    TALENYA: 'assets/img/favicon.png',
};
